export const numberFormat = (value, decimal) => {
  return value.toLocaleString("en-IN", {
    minimumFractionDigits: decimal,
  });
};
